import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { JANUARY_2026_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(JANUARY_2026_CAMPAIGN_END_DATE);
